export default __webpack_public_path__ + "static/media/bluecurve.454a0950.svg";